import { PageState } from 'models/PageState';
import { isKnowledgebasePage } from 'models/KnowledgebasePageModel';

export const TYPE_FUNCTION = 'funktion';
export const TYPE_HOUSE = 'hustyp';
export const TYPE_PRODUCT = 'produktområde';
export const TYPE_SEARCH = 'sök';
export const TYPE_STEPBYSTEP = 'stepByStep';

export const getSearchUrl = (state: PageState) => {
  if (!isKnowledgebasePage(state.currentPage)) {
    return '';
  }

  const item = state.currentPage.menuItems[0].children.find(x => x.type === TYPE_SEARCH);

  if (item !== undefined) {
    return item.url;
  }

  return '';
};

export const getSearchPhrase = (state: PageState) => state.location.search?.phrase;

export const getMenuItems = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage.menuItems : [];

export const selectFunctionLinks = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage.functionLinks : [];

export const selectHouseLinks = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage.houseLinks : [];

export const selectRelatedProductArticles = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage.relatedProductArticles : [];

export const selectRelatedArticles = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage.relatedArticles : [];

export const selectStepByStepArticles = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage.stepByStepArticles : [];

export const getHeader = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage.header : '';

export const getShortBody = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage.shortBody : '';

export const getBody = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage.body : '';

export const getArticle = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage : undefined;

export const getSearchResult = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage.searchResult : undefined;

export const getBreadCrumbs = (state: PageState) =>
  isKnowledgebasePage(state.currentPage)
    ? state.currentPage.breadCrumbs
      ? state.currentPage.breadCrumbs
      : []
    : [];

export const getSubMenuItems = (state: PageState) =>
  isKnowledgebasePage(state.currentPage) ? state.currentPage.children : [];
